import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import { SettingsTab } from '@databox/types/domains/settings/settings.enums';

import type { Service } from 'webapp-types';

export default class SettingsRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;

	protected get chatRoute(): string {
		return 'genie';
	}

	override beforeModel(transition: PublicTransition): void {
		const tab = transition.to?.queryParams?.tab;

		this.navigationService.replaceRoute(this.chatRoute, {
			queryParams: { customize: tab || SettingsTab.PERSONALIZATION },
		});
	}
}
